import { motion, useReducedMotion } from 'framer-motion'
const EASE = [0.16, 1, 0.3, 1]
export default function RevealSection({
  eyebrow,
  title,
  subtitle,
  children,
  bleed = false,
  className = '',
  id,
}) {
  const reduceMotion = useReducedMotion()
  const container = {
    hidden: {},
    visible: {
      transition: { staggerChildren: reduceMotion ? 0 : 0.09 },
    },
  }
  const item = {
    hidden: { opacity: 0, y: reduceMotion ? 0 : 28 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: reduceMotion ? 0.2 : 0.7, ease: EASE },
    },
  }
  return (
    <motion.section
      id={id}
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      className={`relative scroll-mt-14 border-t border-m1-line-soft py-[var(--section)] ${className}`}
    >
      <div className={bleed ? '' : 'max-w-[1200px] mx-auto px-[var(--gutter)]'}>
        <header className={bleed ? 'max-w-[1200px] mx-auto px-[var(--gutter)]' : ''}>
          {eyebrow && (
            <motion.p variants={item} className="text-[14px] text-m1-muted">
              {eyebrow}
            </motion.p>
          )}
          <motion.h2
            variants={item}
            className="mt-4 font-m1-display text-[clamp(36px,4.6vw,58px)] font-medium sm:font-normal leading-[1.04] tracking-[-0.015em] text-m1-ink"
          >
            {title}
          </motion.h2>
          {subtitle && (
            <motion.p
              variants={item}
              className="mt-6 max-w-[30em] text-[19px] font-light leading-relaxed text-m1-ink-soft"
            >
              {subtitle}
            </motion.p>
          )}
        </header>

        <motion.div variants={item} className="mt-12 sm:mt-16">
          {children}
        </motion.div>
      </div>
    </motion.section>
  )
}
